<template>
  <div>
    <div class="title">
      {{ reference }}
      <span @click="$bvModal.show('reference-modal')" class="material-title-edit">
        <font-awesome-icon class="font-awesome-icon" icon="pen-square"/>
      </span>
    </div>

    <b-modal ref="reference-modal" id="reference-modal" size="sm" centered hide-footer>
      <template slot="modal-header">
        <h4 class="modal-title">Vul uw projectreferentie in</h4>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-group">
              <input
                id="reference"
                type="text"
                class="form-control"
                :class="{'is-invalid': $v.reference.$error, 'is-valid': !$v.reference.$error && $v.reference.$dirty}"
                v-model="reference"
                @blur="$v.reference.$touch()"
                autofocus
              >
              <span v-if="!$v.reference.minLength" class="invalid-feedback" role="alert">
                <strong>Vul a.u.b. 3 karakters of meer in.</strong>
              </span>
              <span v-if="!$v.reference.maxLength" class="invalid-feedback" role="alert">
                <strong>Vul a.u.b. minder dan 100 karakters in.</strong>
              </span>
            </div>

            <div class="row justify-content-center mt-2">
              <div class="col-md-13">
                <button
                  type="submit"
                  class="btn btn-oldevuuren w-100 btn-round"
                  :disabled="$v.$invalid"
                  :class="{'disabled cursor-not-allowed': $v.$invalid}"
                >
                  Referentie opslaan
                </button>
              </div>
            </div>
          </form>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import { minLength, maxLength, required } from 'vuelidate/lib/validators'
  import { MUTATE_CART_REFERENCE, MUTATE_DISABLE_PANEL_INPUT } from '../../../store/types'

  export default {
    data() {
      return {
        disablePanelInput: null
      }
    },
    validations: {
      reference: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      }
    },
    computed: {
      reference: {
        get() {
          return !this.$store.getters.cartReference ? '' : this.$store.getters.cartReference
        },
        set(value) {
          this.$store.commit(MUTATE_CART_REFERENCE, value)
        }
      }
    },
    methods: {
      showModal() {
        this.$refs['reference-modal'].show()
      },
      onSubmit() {
        // Close the modal
        this.$refs['reference-modal'].hide()
      }
    },
    mounted() {
      this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        if (this.$store.getters.disablePanelInput) {
          // Temporary disable, to prevent double modals
          this.disablePanelInput = true
          this.$store.commit(MUTATE_DISABLE_PANEL_INPUT, false)
        }
      })
      this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
        if (this.disablePanelInput) {
          this.disablePanelInput = false
          this.$store.commit(MUTATE_DISABLE_PANEL_INPUT, true)
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  .material-title-edit {
    color: $light-grey;
    cursor: pointer;
    font-size: 0.5em;
    padding-left: 5px;
  }
</style>
